import React, { useEffect } from 'react';
import './styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getTasksRequest, updateTaskRequest } from '../../actionCreators/employeeOnboarding';
import OnboardingComponent from '../../components/EmployeeOnboarding';
import { logFirebaseEvent } from '../../firebase/analytics';
import { useParams } from 'react-router-dom';

const EmployeeOnboarding = (props) => {
  const { firstTimeLogin } = useParams();

  useEffect(() => {
    props.getOnboardingTasks();
  }, []);

  return <OnboardingComponent {...props} firstTimeLogin={firstTimeLogin} />;
};

const EmployeeOnboardingContainer = (props) => {
  const state = useSelector((state) => ({
    tasks: state.employeeOnboard.tasks,
  }));

  const dispatch = useDispatch();

  const actions = {
    getOnboardingTasks: () => dispatch(getTasksRequest()),
    updateOnboardingTask: (taskId) =>
      dispatch(
        updateTaskRequest({ taskId }),
        logFirebaseEvent({
          event: 'employee_onboarding',
          action: 'task_completed',
        }),
      ),
  };

  return <EmployeeOnboarding {...props} {...state} {...actions} />;
};

export default EmployeeOnboardingContainer;
